import { AuxiliumComponent } from "../auxilium-component";

export class Beacon extends AuxiliumComponent {
	constructor() {
		super();

		this.variation = this.getAttribute("variation") ?? "theme";
		this.size = this.getAttribute("size");
		this.paused = this.hasAttribute("paused");
	}

	parsedCallback() {
		this.classList.add("beacon", `beacon--${this.variation.toLowerCase()}`);

		if (this.size) { this.classList.add(`beacon--${this.size.toLowerCase()}`) };
		if (this.paused) { this.classList.add("beacon--off"); }
	}
}